import { configureStore } from "@reduxjs/toolkit";
import articulosReducer from "./slices/articulosSlice";

export const store = configureStore({
  reducer: {
    articulos: articulosReducer,
  },
});
